module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAAAXNSR0IArs4c6QAAAFdJREFUGBlj+P///1EgJhYcZQCqFAfiK0ToAKmRYAABIEMEiM/j0QSSEwErhhFAAUEgPolF0ymQHEwdCg2U4APiw0iajoDEUBShc4AKuIF4BxDvBLHR5QEmgcNNS+KQAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav-pc/down.png
// module id = mSWR
// module chunks = 4